export default "__VITE_ASSET__8572d8a8__"